export class ClassificationRequest {
    item: ClassificationRequestItem;
    ship_to_country: string;
}

export class ClassificationRequestItem {
    id: string;
    brand: string;
    category: string;
    description: string;
    detail: string;
    hs_code: string;
    image_url: string;
    language_code: string;
    upc_code: string;
}



// WEBPACK FOOTER //
// ./app/objects/zonos/classificationRequest.ts